// Wrap all iframes in a div to allow for responsive sizing
const wrapIframes = () => {
  const iframes = document.querySelectorAll("iframe");
  if (!iframes) return;

  iframes.forEach((item) => {
    // check if item id contains 'gform'
    if (item.id.includes("gform") || item.getAttribute("data-wrap") === false) {
      return false;
    } else {
      const src = item.getAttribute("data-src");
      if (src) {
        item.setAttribute("src", src);
      }
      const wrapper = document.createElement("div");
      wrapper.classList.add("iframe-wrapper");
      item.parentNode.insertBefore(wrapper, item);
      wrapper.appendChild(item);
    }
  });
};

export default wrapIframes;
